import QtyNumberInput from './QtyNumberInput'
export default QtyNumberInput
